var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"name":"loginPage","login-screen":""}},[_c('login',{attrs:{"has-restore-pass":true,"has-remember-me":true,"has-need-help":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }